/* eslint sort-keys: "error" */

const en = {
  'about-service-feedback': 'About the service and feedback',
  'about-services-feedback': 'About the service and feedback',
  'about-these-pages': 'About the web pages',
  'about-this-service': 'About the service',
  access_with: 'access with',
  accessibility: 'Accessibility',
  'accessibility-limited': 'Wheelchair',
  'accessibility-nolimit': 'No limits',
  'accessibility-statement': 'Accessibility statement',
  'add-favourite-bikeStation-failed-heading': 'Saving the citybike station failed',
  'add-favourite-place-failed-heading': 'Unable to save location',
  'add-favourite-route-failed-heading': 'Saving the route failed',
  'add-favourite-station-failed-heading': 'Saving the station failed.',
  'add-favourite-stop-failed-heading': 'Saving the stop failed',
  'add-home': 'Add home',
  'add-itinerary-via-point': 'Add via point for itinerary',
  'add-location-to-favourites': 'Add an important location to your Favorites',
  'add-to-favourites': 'Add to your Favorites',
  'add-via-button-label': 'Add via point',
  'add-via-duration-button-label': 'Set stop duration at via point {index}',
  'add-via-duration-button-label-close': 'Close stop duration selector at via point {index}',
  'add-via-duration-button-label-open': 'Open stop duration selector at via point {index}',
  'add-work': 'Add work',
  address: 'Address',
  'address-or-stop': 'Address or stop',
  agency: 'Operator',
  airplane: 'Flight',
  'airplane-with-route-number': 'Flight {routeNumber}',
  'airport-check-in': 'Check-in immediately upon arrival if you have not completed check-in in advance',
  'airport-collect-luggage': 'Collect your luggage',
  'airport-security-check-go-to-gate': 'Proceed to your gate through security check',
  all: 'All',
  'all-routes': 'All routes',
  'all-routes-disabled': 'No routes',
  'alternative-legs': 'Also {leg1} at {startTime1} and {leg2} at {startTime2}',
  'alternative-legs-single': 'Also {leg1} at {startTime1}',
  'approx-meters': '{approxDistance} m',
  'aria-itinerary-summary':
    'Total journey time {duration}. Departing at {inFuture} {departureTime} and arriving at {arrivalTime}',
  'aria-itinerary-summary-bike-distance': 'Total cycling {duration}, {distance} ',
  'aria-itinerary-summary-car-distance': 'Total driving {duration}, {distance} ',
  'aria-itinerary-summary-walk-distance': 'Total walking {duration}, {distance} ',
  'arrive-leave': 'Arrive or leave at selected time',
  'arriving-at': 'Arriving',
  'arriving-soon': 'Now',
  'as-destination': 'Destination',
  'as-origin': 'Origin',
  'as-viapoint': 'Viapoint',
  'at-time': 'at',
  'avoid-transfers': 'Avoid transfers',
  'avoid-walking': 'Avoid walking',
  back: 'Back',
  'back-button-title': 'Go back to previous page',
  'back-to-front-page': 'Back to the front page',
  bicycle: 'Bike',
  'bicycle-distance-duration': 'Bike {duration} ({distance})',
  'bicycle-walk-from-transit': 'Take your bike off the {transportMode} and walk it for {distance} ({duration})',
  'bicycle-walk-from-transit-no-duration': 'Walk your bike off the {transportMode}',
  'bicycle-walk-to-transit': 'Walk your bike for {distance} ({duration}) and take it on the {transportMode}',
  'bicycle-walk-to-transit-no-duration': 'Walk your bike to the {transportMode}',
  bicycle_frame_lock: 'Frame locking',
  bicycle_walk: 'Walking a bike',
  'bike-availability': 'Bikes available at the station right now',
  'bike-not-allowed-bus': 'Bikes are not allowed on the bus',
  'bike-not-allowed-tram': 'Bikes are not allowed on the tram',
  'bike-only': 'Cycling only',
  'bike-park': 'Park & Ride for bikes',
  'bike-park-disclaimer':
    'You can conveniently combine cycling and public transport: leave your bike at a Park & Ride and continue by train, bus, metro or tram. Bike parking is free of charge and there are no time limits.',
  'bike-park-disclaimer-header': 'Park your bike',
  'bike-park-disclaimer-link': 'Read more about Park & Ride for bikes',
  'bike-station-disabled': 'The bike station is out of service.',
  'bikes-available': '{amount} bikes at the station ',
  'biketransport-citybike': 'I\'m using a citybike',
  'biketransport-only-bike': 'I\'m travelling only by bike',
  'biking-amount': 'Amount of biking',
  'biking-speed': 'Biking speed',
  'book-a-lift': 'TO DO',
  bus: 'Bus',
  'bus-express': 'Trunk bus',
  'bus-express-with-route-number': 'Trunk bus {routeNumber} {headSign}',
  'bus-local': 'Neighbourhood bus',
  'bus-with-route-number': 'Bus {routeNumber} {headSign}',
  buy: 'Buy',
  'buy-in-app': 'Buy in App',
  'buy-ticket': 'How to buy a ticket',
  call: 'Call {number}',
  cancel: 'Cancel',
  canceled: 'Canceled',
  'canceled-itineraries-amount':
    'Additional {itineraryAmount, plural, =1 {1 canceled itinerary} other {{itineraryAmount} canceled itineraries}}',
  'canceled-itineraries-amount-hide': 'Hide canceled itineraries ({itineraryAmount})',
  'canceled-legs': 'Canceled departures on the route',
  'capacity-modal.crushed-standing-room-only-body': 'Only a little standing room available',
  'capacity-modal.crushed-standing-room-only-heading': 'Very crowded',
  'capacity-modal.few-seats-available-body': 'Some seats available',
  'capacity-modal.few-seats-available-heading': 'Not too crowded',
  'capacity-modal.full-capacity-body': 'No seats or standing room available',
  'capacity-modal.full-capacity-heading': 'Full',
  'capacity-modal.heading': 'Is there room in the vehicle?',
  'capacity-modal.legend': 'Legend for the symbols',
  'capacity-modal.many-seats-available-body': 'Plenty of seats available',
  'capacity-modal.many-seats-available-heading': 'Not crowded',
  'capacity-modal.standing-room-only-body': 'Only a few seats and little standing room available',
  'capacity-modal.standing-room-only-heading': 'Nearly full',
  'capacity-modal.subheading': 'Real-time capacity information is available for some vehicles',
  car: 'Car',
  'car-distance-duration': 'Drive {duration} ({distance})',
  'car-distance-no-duration': 'Drive {distance}',
  'car-drive-from-transit-no-duration': 'Drive your car from the {transportMode}',
  'car-drive-to-transit-no-duration': 'Drive your car to the {transportMode}',
  'car-park': 'Park & ride',
  'car-park-disclaimer':
    'You can conveniently combine car and public transport: leave your car at a Park & Ride and continue by train, bus, metro or tram. Car parking is free of charge and there are no time limits.',
  'car-park-disclaimer-header': 'Park your car',
  'car-park-disclaimer-link': 'Read more about Park & Ride',
  cause: 'cause',
  'char-left': 'characters',
  'choose-freely': 'Optional',
  'choose-stop': 'Select stop',
  'choose-stop-or-vehicle': 'Select vehicle or stop',
  'choose-vehicle': 'Select vehicle',
  citybike: 'City bike',
  'citybike-buy-season': 'Buy a ticket for day, month or year',
  'citybike-distance-duration': 'Bike {duration} ({distance})',
  'citybike-duration-general-header':
    'Extra charge applies to several sections of route to be completed by a city bike.',
  'citybike-duration-info':
    'You can ride a city bike for up to {duration} minutes at a time, after which you will be charged extra.',
  'citybike-duration-info-header':
    'The section of route to be completed by a city bike takes more than {duration} minutes.',
  'citybike-duration-info-short': 'Section of route takes more than {duration} min. Extra charge applies.',
  'citybike-network-header': 'Citybikes and scooters',
  'citybike-network-headers': 'Citybikes',
  'citybike-purchase-link': 'Buy',
  'citybike-register-required': 'To use city bikes, you need to register',
  'citybike-return-full': 'Returning a city bike?',
  'citybike-return-full-link': 'How to return a bike when a bike station is full ›',
  'citybike-start-using': 'Start using city bikes',
  'citybike-start-using-info': 'More information',
  'citybike-station': 'Bike station {stationId}',
  'citybike-station-no-id': 'Bike station',
  'clear-button-label': 'Clear',
  close: 'Close',
  'close-favourite-module': 'Close the Favorites module',
  'close-settings': 'Close window and save settings',
  continue: 'Continue',
  'cookie-settings': 'Cookie settings',
  'copy-code': 'Copy the code',
  covered: 'Sheltered',
  'create-account': 'Create {contactName} account',
  'create-embedded-search': 'Create a route search element',
  'create-stop-monitor': 'Create a stop display',
  'crushed-standing-room-only': 'Crushed standing room only',
  currentposition: 'Current position',
  'cycle-distance-duration': 'Cycle {duration} ({distance})',
  'cyclewalk-distance-duration': 'Walk your bike {duration} ({distance})',
  datasources: 'Data sources',
  date: 'Date',
  day: 'Day',
  delete: 'Delete',
  'delete-favourite-failed-heading': 'Unable to delete save',
  'departure-list-update.sr-instructions': 'The list of upcoming departures and departure times will update in real time.',
  'departure-page-sr': 'Trip {shortName} {destination} {time} information',
  'departure-time-in-minutes': '{minutes} min',
  'departure-time-sr': '{when} clock {time}. {realTime}',
  departures: 'Departures',
  'departures-by-hour': 'Departures by hour',
  'departures-by-hour-minutes-route': '(minutes/route)',
  'departures-not-found': 'Unfortunately, no timetable was found for the stop you selected',
  'departures-not-found-time-threshold':
    'Unfortunately, no timetable was found for the stop you selected. It is possible that the day you searched for is too ar in the future. Please try again nearer to the time of your journey',
  description: 'Find public transport services to locations near and far.',
  destination: 'Destination',
  'destination-defined': 'Destination defined',
  'destination-label-change': 'Change destination',
  'destination-outside-service':
    'No route suggestions were found because the destination is outside the service area.',
  'destination-placeholder': 'Enter destination, route or stop',
  'dialog-return-to-map': 'Return to map',
  'digitransit-platform': 'Digitransit service platform',
  disclaimer:
    'Please note that the results are based on estimated travel times. The suggested transport connections cannot be guaranteed.',
  disruption: 'Disruption',
  'disruption-info': 'Disruption info',
  'disruption-info-no-alerts': 'No known disruptions or diversions.',
  'disruption-info-route-no-alerts': 'No known disruptions or diversions to the route.',
  disruptions: 'Disruptions',
  'disruptions-and-diversions': 'Disruptions and diversions',
  'disruptions-tab.sr-disruptions': 'One or more known disruptions',
  'disruptions-tab.sr-no-disruptions': 'No known disruptions',
  'distance-between': 'Distance {distance1} m — {distance2} m',
  'distance-total': 'Total distance',
  'distance-under': 'Distance less than {distance} m',
  'e-scooter': 'Electric scooter',
  'e-scooter-alternative': 'How about using an electric scooter for part of your journey? {paymentInfo}',
  'e-scooter-disclaimer-close': 'Close scooter disclaimer',
  'e-scooter-or-taxi-alternative':
    'How about using a taxi or an electric scooter for part of your journey? {paymentInfo}',
  'e-scooter-station': 'Electric scooter station',
  'e-scooters': 'Electric scooters',
  'e-scooters-available':
    'There are electric scooters available in the area. Use an app to unlock the electric scooter.',
  earlier: 'Earlier departures',
  'edit-favourites': 'Edit the location in the Favorites',
  'elevation-gained-total': 'Elevation gained',
  'elevation-lost-total': 'Elevation lost',
  'embedded-search.choose-language': 'Language',
  'embedded-search.choose-mode': 'Means of transport',
  'embedded-search.choose-width-component': 'Width of the embedding ',
  'embedded-search.form-heading': 'Embedding tools',
  engine_ignition_aid: 'Engine starting aid',
  english: 'English',
  explanations: 'Explanations',
  'extra-info': 'More info',
  'favourite-failed-text': 'Please try again in a while.',
  'favourite-target': 'Favorite location',
  ferry: 'Ferry',
  'ferry-external': 'Ferry',
  'ferry-external-with-route-number': 'Ferry {routeNumber} {headSign}',
  'ferry-with-route-number': 'Ferry {routeNumber} {headSign}',
  'fetch-new-route': 'Fetch a new route',
  'few-seats-available': 'Few seats available',
  finnish: 'Finnish',
  'free-of-charge': 'Free',
  'from-bus': 'bus',
  'from-ferry': 'ferry',
  'from-ferrypier': 'ferry pier',
  'from-rail': 'train',
  'from-scooter-location': 'the scooter location',
  'from-station': 'station',
  'from-stop': 'stop',
  'from-subway': 'subway',
  'from-tram': 'tram',
  frontpage: 'Frontpage',
  full: 'Full capacity',
  funicular: 'Funicular',
  'generic-cancelation': '{mode} {route} {headsign} at {time} is cancelled.',
  'generic-error': 'There was an error',
  'geolocate-yourself': 'Detect your location',
  'geolocation-denied-heading': 'Geolocation denied',
  'geolocation-denied-text':
    'You have not given a permission to use your geolocation. You can allow it from the phone or browser settings.',
  'geolocation-failed-heading': 'Geolocation failed',
  'geolocation-failed-text': 'Your browser does not support location retrieval.',
  'geolocation-prompt-text': 'Accept your browser’s request to access your location.',
  'geolocation-timeout-heading': 'Detecting your location is taking longer than expected.',
  'geolocation-timeout-text': 'Have you accepted your browser’s request to access your location?',
  'give-destination': 'Enter your destination',
  'give-name-to-location': 'Give the location a descriptive name',
  'give-origin': 'Enter your origin.',
  'give-position': 'Enter your location or origin in the search field.',
  'give-route': 'Search route',
  hour: 'Hour',
  'hour-short': 'h',
  'how-to-rate-service': 'How would you rate the service?',
  hsl_mobile_ticket: 'HSL mobile ticket',
  hsl_ticket: 'HSL ticket',
  hsl_travel_card: 'HSL card',
  'in-addition': 'In addition',
  'include-estonia': 'Include Estonia',
  'index.title': 'Journey Planner',
  inquiry: 'How did you find the new Journey Planner? Please tell us!',
  instructions: 'Instructions',
  'is-open': 'Open:',
  'itinerary-co2.description':
    '{co2value} g of CO₂ emissions will be generated on this journey. A car would generate {carCo2Value} g of CO₂ on the same journey.',
  'itinerary-co2.description-simple': '{co2value} g of CO₂ emissions will be generated on this journey.',
  'itinerary-co2.description-simple-sr': '{co2value} g of carbondioxide emissions will be generated on this journey.',
  'itinerary-co2.description-sr':
    '{co2value} g of carbondioxide emissions will be generated on this journey. A car would generate {carCo2Value} g of carbondioxide on the same journey.',
  'itinerary-co2.link': 'This is how we reduce emissions ›',
  'itinerary-co2.title': 'CO₂ emissions of the journey',
  'itinerary-co2.title-sr': 'Carbondioxide emissions of the journey',
  'itinerary-details.biking-leg':
    'At {time} cycle {distance} from {origin} to {to} {destination}. Estimated time {duration}',
  'itinerary-details.car-leg':
    'At {time} drive {distance} from {origin} to {to} {destination}. Estimated time {duration}',
  'itinerary-details.end-leg': 'At {time} arrive to destination {destination}.',
  'itinerary-details.route-has-info-alert': 'Route has alerts.',
  'itinerary-details.route-has-severe-alert': 'Route has disruptions.',
  'itinerary-details.route-has-unknown-alert': 'Route has disruptions.',
  'itinerary-details.route-has-warning-alert': 'Route has disruptions.',
  'itinerary-details.scooter-leg':
    'At {time} travel by scooter {distance} from {origin} to {destination}. Estimated time {duration}',
  'itinerary-details.transit-leg-part-1': 'At {time} {realtime} take',
  'itinerary-details.transit-leg-part-2':
    'from stop {startStop} {startZoneInfo} {trackInfo} to stop {endStop} {endZoneInfo}. Estimated duration {duration}',
  'itinerary-details.via-leg': '{arrivalTime} arrive to via point {viaPoint}. {leaveAction}',
  'itinerary-details.walk-leg':
    'At {time} walk {distance} from {origin} to {to} {destination}. Estimated time {duration}',
  'itinerary-feedback-button': 'Send feedback',
  'itinerary-feedback-message': 'Couldn’t find what you were looking for?',
  'itinerary-feedback-placeholder': 'Description (optional)',
  'itinerary-hide-alternative-legs': 'Hide alternatives',
  'itinerary-hide-stops': 'Hide stops',
  'itinerary-in-the-past': 'The route search falls within a period that is in the past.',
  'itinerary-in-the-past-link': 'Depart now ›',
  'itinerary-in-the-past-title': 'The route options cannot be displayed',
  'itinerary-page.description': 'Itinerary',
  'itinerary-page.hide-details': 'Hide itinerary details',
  'itinerary-page.itineraries-loaded': 'Search results downloaded',
  'itinerary-page.itineraries-updated': 'Search results updated',
  'itinerary-page.loading-itineraries': 'Downloading search results',
  'itinerary-page.show-details': 'Show itinerary details',
  'itinerary-page.show-details-label': 'Show itinerary {number} details',
  'itinerary-page.title': 'Itinerary',
  'itinerary-page.update-alert': 'Search results updated',
  'itinerary-summary-page-street-mode.update-alert': 'Walking and biking results updated',
  'itinerary-summary-page.description': 'Route suggestions',
  'itinerary-summary-page.title': 'Route suggestions',
  'itinerary-summary-row.biking-distance': 'Total biking distance {totalDistance}.',
  'itinerary-summary-row.clickable-area-description': 'Show on map',
  'itinerary-summary-row.description':
    'Itinerary departing at {departureDate} {departureTime} and arriving at {arrivalDate} {arrivalTime}. {firstDeparture} {transfers} Total time {totalTime}.',
  'itinerary-summary-row.first-departure': '{vehicle} leaves at {departureTime} from stop {stopName}.',
  'itinerary-summary-row.first-leg-start-time':
    'Leaves at {firstDepartureTime} from {firstDepartureStopType} {firstDepartureStop}{firstDeparturePlatform}',
  'itinerary-summary-row.first-leg-start-time-citybike': 'Departure at {firstDepartureTime} from {firstDepartureStop} bike station',
  'itinerary-summary-row.first-leg-start-time-scooter': 'Departure at {firstDepartureTime} by a scooter',
  'itinerary-summary-row.no-transit-legs': 'Leave when it suits you',
  'itinerary-summary-row.transfers': 'Transfer to {vehicle} on stop {stopName}',
  'itinerary-summary-row.transfers-to-rental': 'Transfer to {vehicle}',
  'itinerary-summary-row.walking-distance': 'Total walking distance {totalDistance}.',
  'itinerary-summary.bike-boarding-information':
    'You are allowed to bring your bicycle on board the vehicle. Check with the transport operator if the transportation of bicycles is subject to a fee',
  'itinerary-summary.bikeAndPublic-bus-title': 'Take your bike with you on the bus',
  'itinerary-summary.bikeAndPublic-ferry-title': 'Take your bike with you on the ferry',
  'itinerary-summary.bikeAndPublic-rail-subway-title': 'Take your bike with you on the train or subway',
  'itinerary-summary.bikeAndPublic-rail-title': 'Take your bike with you on the train',
  'itinerary-summary.bikeAndPublic-subway-title': 'Take your bike to metro',
  'itinerary-summary.bikeAndPublic-tram-title': 'Take your bike to tram',
  'itinerary-summary.bikePark-title': 'Leave your bike at a Park & Ride',
  'itinerary-summary.car-boarding-information':
    'You can take your car on board. Check with the transport operator if an additional fee will be charged for the transportation of cars.',
  'itinerary-summary.carAndPublic-ferry-title': 'Drive your car to the ferry',
  'itinerary-summary.carAndPublic-rail-title': 'Drive your car to the train',
  'itinerary-summary.interline-wait':
    'The route number ({shortName}) and destination ({destination}) will change at the {stop} stop. Waiting time at the stop is {time}. Please wait onboard.',
  'itinerary-summary.interline-wait-multiple-legs':
    'The route number ({shortName}) and destination will change several times during the journey. Total waiting time is {time}. Please do not leave the vehicle.',
  'itinerary-summary.show-on-map': 'Show on map {target}',
  'itinerary-ticket.title': 'Required ticket',
  'itinerary-tickets.title': 'Required tickets',
  'itinerary-time.title': 'Duration',
  'itinerary-walk.title': 'Total walking distance',
  'journey-planner-manual': 'Journey planner manual',
  'journeyplanner.title': 'HSL Journey Planner',
  'language-selection': 'Language: {language}',
  later: 'Later departures',
  'leave-your-car-park-and-ride': 'Leave your car at Park & Ride site',
  leaves: 'Leaves',
  'leaving-at': 'Leaving at',
  lighting: 'Lighting',
  'likely-to-recommend': 'How likely are you to recommend our service to your friends or colleagues?',
  'likely-to-use': 'How likely are you to use this service rather than the current Journey Planner?',
  loading: 'Loading...',
  localadmin: 'Locality',
  locate: 'Detect location',
  'location-examples': 'e.g. Home, Work, School,...',
  'location-from-map': 'Selected location',
  'location-from-map-confirm': 'Confirm selection',
  'location-home': 'Home',
  'location-school': 'School',
  'location-shopping': 'Shopping',
  'location-sport': 'Sports',
  'location-work': 'Work',
  login: 'Log in',
  'login-content':
    'To save and utilize places, routes and stops, you must log in using your HSL account.',
  'login-header': 'Log in First',
  logout: 'Log out',
  'long-transfers-margin': '12 min',
  'main-menu-label-close': 'Close the main menu',
  'main-menu-label-open': 'Open the main menu',
  'main-mode': 'I\'m traveling by',
  'many-seats-available': 'Many seats available',
  map: 'Map',
  'map-layer-citybike': 'Citybike stations',
  'map-layer-park-and-ride': 'Park & ride sites',
  'map-layer-park-and-ride-bike': 'Park & ride bike parking',
  'map-layer-scooter': 'Scooters',
  'map-layer-stop-bus': 'Bus stops',
  'map-layer-stop-ferry': 'Ferries',
  'map-layer-stop-funicular': 'Funiculars',
  'map-layer-stop-tram': 'Tram stops',
  'map-layer-terminal-bus': 'Bus terminals',
  'map-layer-terminal-rail': 'Train stations',
  'map-layer-terminal-subway': 'Metro stations',
  'map-layer-vehicles': 'Vehicles',
  'map-zoom-in-button': 'Zoom in',
  'map-zoom-out-button': 'Zoom out',
  'menu-about-digitransit': 'About Digitransit',
  'menu-copyright-nwsnet': '© die NetzWerkstatt GmbH & Co. KG {year}',
  'menu-copyright-prod': 'The Schleswig-Holstein Navi is a joint project of Kreis Schleswig-Flensburg and Amt Hüttener Berge - © {year}',
  'menu-faq': 'FAQ',
  'menu-feedback': 'Submit feedback',
  'menu-impressum': 'Legal notice',
  'menu-link-to-privacy-policy': 'Privacy policy',
  'messagebar-label-close-message-bar': 'Close banner',
  'messagebar-label-page': 'Page',
  'min-transfer-time': 'Interchange time',
  'minute-short': 'min',
  minutes: 'min',
  'minutes-or-route': 'Min / Route',
  'mobile-ticket-purchase-aria':
    'Mobile ticket purchase information. Buy {ticketName} for {price}. Buy ticket from HSL app or download the app',
  'modes.from-place': 'from the destination',
  'modes.to-airplane': 'airport',
  'modes.to-bike': 'city bike station',
  'modes.to-bike-park': 'bike park',
  'modes.to-bus': 'bus stop',
  'modes.to-car-park': 'car park',
  'modes.to-ferry': 'ferry pier',
  'modes.to-place': 'destination',
  'modes.to-rail': 'train station',
  'modes.to-scooter': 'to scooter',
  'modes.to-stop': 'stop',
  'modes.to-subway': 'subway station',
  'modes.to-tram': 'tram stop',
  'more-departures': 'More departures',
  'more-settings': 'More settings',
  'move-on-map': 'Move on the map',
  'move-to-tab': 'Go to tab {number}',
  'navi-change-info': 'TODO_Saat tiedon muutoksista',
  'navi-geolocation-approval': 'TODO_Suostumuksesi sijaintitietoihin palvelua käytettäessä',
  'navi-geolocation-details':
    'TODO_Opastuksen alkaessa palvelu voi pyytää suostumuksesi sijaintiedon käyttämiseen. Voit määrittää luvan laitteesi ja selaimen asetuksista milloin tahansa.',
  'navi-geolocation-purpose': 'TODO_Sallimalla laitteesi paikannuksen saat parhaan mahdollisen tuen reitillesi.',
  'navi-more-guidance': 'TODO_Entistä opastetummin perille!',
  'navi-support': 'TODO_Saat tukea reitilläsi',
  'navidest-show-on-map': 'Show route on map',
  navigate: 'Navigate',
  'navigation-abort-trip': 'Unfortunately your journey plan is not possible.',
  'navigation-description': 'Journey guidance',
  'navigation-get-mode': 'Get on the {mode}',
  'navigation-hurry-transfer': 'Shorter transfer time',
  'navigation-hurry-transfer-solved': 'Transfer time returned to normal',
  'navigation-hurry-transfer-solved-details': 'Transfer time for {transfer} is again {time}',
  'navigation-hurry-transfer-value': 'Transfer time for {transfer} is {time}',
  'navigation-interline-resume': 'TODO_Matka jatkuu {duration} odotuksen jälkeen',
  'navigation-interline-wait': 'TODO_Linjatunnus {line} Ja määränpää {destination} vaihtuvat pysäkillä',
  'navigation-intro-begin': 'TODO_navigation-intro-begin_EN',
  'navigation-intro-header': 'TODO_navigation-intro-login-prompt_EN',
  'navigation-intro-help-body': 'TODO_navigation-intro-login-prompt_EN',
  'navigation-intro-help-header': 'TODO_navigation-intro-login-prompt_EN',
  'navigation-intro-notifications-body': 'TODO_navigation-intro-login-prompt_EN',
  'navigation-intro-notifications-header': 'TODO_navigation-intro-login-prompt_EN',
  'navigation-journey-start': 'Your journey starts at',
  'navigation-journey-start-early-prompt': 'TODO_navigation-journey-start-early-prompt_EN',
  'navigation-mode-canceled': 'TODO_{name} on peruuntunut',
  'navigation-mode-early': 'TODO_{name} on etuajassa',
  'navigation-mode-late:': 'TODO_{name} on myöhässä',
  'navigation-outro-dismiss': 'Exit Navigator',
  'navigation-outro-header': 'TODO_navigation-outro-header_EN',
  'navigation-quit': 'Return',
  'navigation-remember-ticket': 'TODO_Muistithan ostaa lipun?',
  'navigation-ticket': 'Ticket',
  'navigation-transfer-problem': 'Transfer is no longer possible',
  'navigation-transfer-problem-details': 'Transfer {transfer} is too fast.',
  'navileg-at-ferrypier': 'ferry pier',
  'navileg-at-station': 'station',
  'navileg-at-stop': 'stop',
  'navileg-bicycle': 'Cycle to',
  'navileg-car': 'Drive to',
  'navileg-departing-at': 'TODO_{duration} päästä klo {legTime}',
  'navileg-hop-on': 'TODO_ja nouse kyytiin',
  'navileg-in-transit': 'TODO_{mode}matka',
  'navileg-in-transit-interline':
    'TODO_Matka jatkuu {stopOrStation} {stop} samassa kulkuneuvossa {duration} päästä klo {legTime}',
  'navileg-intermediate-stops': 'TODO_{stopCount} välipysäkkiä',
  'navileg-leave-at': 'Jää pois {stopOrStation} {stop} {duration} päästä klo {legTime}',
  'navileg-mode-citybike': 'TODO_Kaupunkipyöriä on asemalla {available} kpl',
  'navileg-mode-realtime': '{mode} {route} on aikataulussa',
  'navileg-mode-schedule': 'No up-to-date traffic data available',
  'navileg-one-intermediate-stop': 'TODO_{stopCount} välipysäkki',
  'navileg-rent-cycle': 'Pick up citybike',
  'navileg-rent-scooter': 'Pick up scooter',
  'navileg-scooter': 'Travel by scooter to',
  'navileg-start-realtime': 'Lähtee klo {time} {stop} {stopName}',
  'navileg-start-schedule': '{mode} {route} aikataulun mukainen lähtö {time}',
  'navileg-walk': 'Walk to',
  nearest: '{ mode } near you',
  'nearest-favorites': 'Stops nearby me',
  'nearest-favorites-browse-stops': 'Browse and select stops',
  'nearest-favorites-no-favorites': 'Timetables for the selected stops and vehicles on map',
  'nearest-no-stops': 'There are no stops or stations for the selected mode of transport nearby.',
  'nearest-stops': 'The closest stops',
  'nearest-stops-airplane': 'airports',
  'nearest-stops-bus': 'bus stops',
  'nearest-stops-citybike': 'bike stations',
  'nearest-stops-favorite': 'stops nearby me',
  'nearest-stops-ferry': 'ferry piers',
  'nearest-stops-rail': 'train stations',
  'nearest-stops-subway': 'metro stations',
  'nearest-stops-tram': 'tram stops',
  'nearest-stops-update-location': 'Update {mode}',
  'nearest-stops-updated-location': 'Location on the map has changed',
  neighbourhood: 'Neighbourhood ',
  'network-error': 'Network error',
  'new-route': 'Is the route new for you?',
  next: 'Next',
  'no-bike-allowed-popup-train':
    'Bicycles are allowed on commuter trains but on long distance trains you have to pay an extra fee and it might require a reservation.',
  'no-bike-allowed-popup-tram-bus':
    'Bicycles are not allowed on buses or trams. If you are using these vehicles on your route, leave the bicycle at the stop or at a Park-and-Ride. ',
  'no-departures': 'No departures',
  'no-more-route-msg': 'No additional itineraries were found',
  'no-position': 'No location',
  'no-position-no-stops': 'Your location is not available. We are unable to show the closest stops.',
  'no-route-already-at-destination': 'You are already at your destination.',
  'no-route-end': 'Please select destination',
  'no-route-end-date-not-in-range': 'The current timetable does not contain any later departures.',
  'no-route-found': 'Unfortunately, route {shortName} ({longName}) could not be found.',
  'no-route-msg': 'Unfortunately, no route suggestions were found',
  'no-route-msg-time-threshold':
    'Unfortunately, no route suggestions were found. It is possible that no timetables can yet be found for the day you selected. Please try again nearer to the time of your journey',
  'no-route-msg-with-changes':
    'Unfortunately, no route suggestions were found. Please check your search settings or try changing the origin or destination.',
  'no-route-origin-near-destination':
    'No route suggestions were found because the origin and destination are very close to each other.',
  'no-route-origin-same-as-destination': 'No route suggestions were found because the origin and destination are the same.',
  'no-route-showing-alternative-options':
    'No route suggestions were found with the your settings. However, we found the following route options:',
  'no-route-start': 'Please select origin',
  'no-route-start-date-too-early': 'The current timetable does not contain any earlier departures.',
  'no-route-start-end': 'Please select origin and destination',
  'no-transfers-margin': '1 min',
  'no-trips-found': 'No journeys found for the selected date ({selectedDate}).',
  'notification-minimize': 'Close message',
  'notification-open': 'Open message',
  now: 'Now',
  'number-of-intermediate-stops': '{number, plural, =0 {No stops} one {1 stop} other {{number} stops} }',
  'number-of-minutes': '{number, plural, =0 {0 minutes} one {1 minute} other {{number} minutes}}',
  'number-of-spaces': 'Number of spaces:',
  'off-canvas-info': 'Log in to the service to save your favorites and utilize them on other devices',
  'one-way-journey': 'The length of a one-way journey',
  'open-app': 'Open the app',
  'open-operator-app': 'Open the {operator} app',
  'open-settings': 'Open the settings',
  'option-default': 'Average',
  'option-least': 'Slow',
  'option-less': 'Calm',
  'option-more': 'Prompt',
  'option-most': 'Fast',
  or: 'or',
  origin: 'Origin',
  'origin-and-destination': 'Origin and destination',
  'origin-defined': 'Origin defined',
  'origin-label-change': 'Change origin',
  'origin-outside-service': 'No route suggestions were found because the origin is outside the service area.',
  'origin-placeholder': 'From? - address or stop',
  'other-dates': 'Other dates',
  'own-position': 'Your current location',
  'page-not-found': 'The page cannot be found.',
  paid: 'Paid',
  'park-and-ride': 'Park and Ride',
  'park-and-ride-availability': 'Spaces available:',
  'park-and-ride-unknown': 'Unknown capacity',
  'pay-attention': 'N.B.',
  'payment-info-e-scooter':
    'Please note that you need to use the app of the operator in question in order to use and pay for the scooters.',
  'payment-info-e-scooter-taxi':
    'Please note that you need to use the app of the operator in question in order to use and pay for the taxis or scooters.',
  'payment-info-taxi-lifts':
    'Huomaathan, että taksien ja kyytipalveluiden käyttö ja maksaminen tapahtuu toimijoiden omilla sovelluksilla.',
  payment_at_gate: 'Payment at the gate ',
  'pick-icon': 'Select icon',
  'pick-mode': 'Transport modes',
  'pick-mode-airplane-disabled': 'Flight not selected',
  'pick-mode-airplane-enabled': 'Flight selected',
  'pick-mode-bus-disabled': 'Bus not selected',
  'pick-mode-bus-enabled': 'Bus selected',
  'pick-mode-citybike-disabled': 'Citybike not selected',
  'pick-mode-citybike-enabled': 'Citybike selected',
  'pick-mode-ferry-disabled': 'Ferry not selected',
  'pick-mode-ferry-enabled': 'Ferry selected',
  'pick-mode-rail-disabled': 'Rail not selected',
  'pick-mode-rail-enabled': 'Rail selected',
  'pick-mode-selected': 'Selected transport modes',
  'pick-mode-subway-disabled': 'Metro not selected',
  'pick-mode-subway-enabled': 'Metro selected',
  'pick-mode-tram-disabled': 'Tram not selected',
  'pick-mode-tram-enabled': 'Tram selected',
  'pick-street-mode': 'My modes of transport',
  'place-route-or-keyword': 'Destination, route or stop',
  platform: 'Platform',
  'platform-num': 'Platform {platformCode}',
  'platform-short': 'Plat. {platformCode}',
  'platform-short-no-num': 'Plat.',
  polish: 'Polish',
  position: 'Position',
  'prefer-walking': 'Prefer walking',
  preview: 'Preview',
  previous: 'Previous',
  print: 'Print',
  'print-timetable': 'Weekly timetable',
  'privacy-statement': 'Privacy statement',
  'public-transport': 'Public transport',
  rail: 'Commuter train',
  'rail-with-route-number': 'Train {routeNumber} {headSign}',
  'read-more': 'Read more',
  realtime: 'Real-time',
  'realtime-matching': 'Real-time integration',
  releases: 'Releases',
  'remove-favourite': 'Remove from favorites',
  'remove-via-button-label': 'Remove via point {index}',
  'rent-cycle-at': 'Fetch a city bike:',
  'rent-e-scooter-at': 'Use an app to unlock the electric scooter',
  'rent-scooter-at': 'Rent a kick scooter at {station} station',
  'required-ticket': 'Ticket required for the journey',
  'restore-default-settings': 'Restore default settings {changedSettingsIndicator}',
  'restore-default-settings-aria-label': 'Restore default settings.',
  'restore-default-settings-aria-label-done': 'Default settings are in use.',
  'return-cycle-to': 'Return the bike:',
  'return-e-scooter-to': 'Leave the scooter in a safe location',
  'return-scooter-to': 'Return the kick scooter to {station} station',
  'right-now': 'Right now',
  route: 'Route',
  'route-add-viapoint': 'Via point',
  'route-custom-settings': 'Custom settings',
  'route-default': 'Default settings',
  'route-destination-arrives': 'Drop-off only',
  'route-destination-endpoint': 'Arrives / Terminus',
  'route-fastest': 'Fast route',
  'route-from-here': 'Origin',
  'route-guide': 'Route guide',
  'route-here': 'Destination',
  'route-least-elevation-changes': 'Avoid changes in elevation',
  'route-least-transfers': 'Avoid transfers',
  'route-least-walking': 'Avoid walking',
  'route-no-stop': 'No stop',
  'route-not-possible': 'Unfortunately, your route is not available. Technical error: "{error}"',
  'route-page-vehicle-position': '{mode} {shortName} is at the {stopName} stop',
  'route-page-vehicle-position-between': '{mode} {shortName} is between the {stopName} stop and the {nextStopName} stop.',
  'route-page-vehicle-selected': 'Current selection.',
  'route-page.description': 'Route {shortName} - {longName}',
  'route-page.future-routes': 'Future routes',
  'route-page.pattern-chosen': 'Selected',
  'route-page.pattern-select-title': 'Select the route to be viewed',
  'route-page.similar-routes': 'You might also be interested in',
  'route-page.special-routes': 'Other routes',
  'route-page.title': 'Route {shortName}',
  'route-page.title-short': 'Route',
  'route-to-ferry': 'Route to the pier',
  'route-to-park': 'Route to the park',
  'route-to-station': 'Route to the station',
  'route-to-stop': 'Route to the stop',
  'router-change-departure-time': 'Change departure time ›',
  'router-location-not-found': 'Please select location on the road network or at a stop.',
  'router-location-not-found-title-1': 'There is no defined access to the destination',
  'router-location-not-found-title-2': 'There is no defined access to the origin',
  'router-location-not-found-title-3': 'There is no defined access to the origin and the destination',
  'router-only-walk':
    'No faster alternatives than walking are available for the route you searched for.',
  'router-only-walk-title': 'Walk the route',
  'router-outside-bounds-3':
    'No route suggestions were found because the origin and destination are outside the service area.',
  'router-outside-service-period': 'Timetable information is not available for the time you selected.',
  'router-stops-in-range-1': 'There are no public transport stops close enough to the selected destination.',
  'router-stops-in-range-2': 'There are no public transport stops close enough to the selected origin.',
  'router-stops-in-range-3':
    'There are no public transport stops close enough to the selected origin and destination.',
  'router-system-error': 'An error occurred in the system. Please try again later.',
  'router-transit-connection': 'Please try changing the origin or destination.',
  'router-transit-connection-in-search-window': 'There are no services available at the selected time.',
  'router-unable': 'Unable to show route options',
  routes: 'Routes',
  'routes-platforms': 'Routes and platforms',
  'routes-tracks': 'Routes and tracks',
  'routing-feedback-header': 'Are you satisfied with the route suggestions?',
  'routing-feedback-link': 'Give feedback',
  run: 'Run',
  save: 'Save',
  scooter: 'Scooter',
  'scooter-availability': 'Kick scooters available at the station right now',
  'scooter-distance-duration': 'Travel by scooter for {duration} ({distance})',
  'scooter-register-required': 'To use kick scooters, you need to register',
  'scooterwalk-distance-duration': 'Walk your kick scooter {duration} ({distance})',
  search: 'Search',
  'search-autosuggest-label': 'Venue, place and stopsearch.',
  'search-autosuggest-label-instructions': 'Navigate list with arrow keys and select with enter key.',
  'search-autosuggest-label-move-to-destination':
    'After selecting the starting location you are automatically moved to the destination field.',
  'search-autosuggest-len':
    'There {len, plural, =1 {is 1 suggestion} other {are {len} suggestions}} available',
  'search-button-label': 'Search',
  'search-current-suggestion': 'Current selection: {selection}',
  'search-destination': 'Search destination, route or stop',
  'search-destination-index': 'Enter destination',
  'search-destination-results-but-no-search': 'View results in the adjacent “Destination” tab',
  'search-fields.sr-instructions':
    'Route search will take place automatically when you enter origin and destination. Changing search parameters will trigger a new search. Navigate to the search fields using the tab key',
  'search-no-results': 'No location',
  'search-origin': 'Search origin, route or stop',
  'search-origin-index': 'Enter origin',
  'search-position': 'Detect location',
  'search-search-results-but-no-destination': 'View results in the adjacent “About the route or stop” tab',
  'searching-position': 'Detecting location...',
  'select-all-routes': 'Select all routes',
  'select-date': 'Select date',
  'select-from-map-destination': 'Select destination',
  'select-from-map-favourite': 'Select from map',
  'select-from-map-no-title': 'No title',
  'select-from-map-origin': 'Select origin',
  'select-from-map-viaPoint': 'Select viapoint',
  'select-map-layers-header': 'Show on map',
  'select-position': 'Select your location from your previous searches',
  'select-route': 'Select {mode} route {shortName} to {headsign}',
  'selected-routes': 'Selected lines',
  send: 'Send',
  'separate-ticket-required': 'A separate ticket is required for this part of the itinerary.',
  'separate-ticket-required-disclaimer':
    'This itinerary contains one or more legs for which {agencyName} does not sell tickets.',
  'separate-ticket-required-for-call-agency-disclaimer':
    'The journey includes demand responsive transport service. Please check the payment methods and practices on ',
  'set-specific-settings': 'Set more specific settings',
  'set-stop-as-routes': 'Set the stop as route\'s',
  'set-time-earlier-button-label': 'Set travel time to earlier',
  'set-time-later-button-label': 'Set travel time to later',
  'set-time-now-button-label': 'Set travel time to current',
  settings: 'Settings {changedSettingsIndicator}',
  'settings-alternative-name-rail': 'Train',
  'settings-change-itinerary-settings': 'Change settings',
  'settings-dropdown-close-label': 'Close options',
  'settings-dropdown-open-label': 'Open options',
  'settings-e-scooter':
    'You can select the electric scooters you want and make them part of the route suggestions. {paymentInfo}',
  'settings-e-scooter-on': 'Make electric scooters a permanent option in your settings',
  'settings-e-scooter-routes': 'Make electric scooters part of your routes!',
  'settings-label-change': 'Change settings',
  'settings-missing-itineraries-body': 'Some selections in the settings exclude certain route alternatives.',
  'settings-missing-itineraries-header': 'Are some route alternatives missing?',
  'settings-taxi-lift': 'Voit valita haluamasi taksi ja kyytipalvelut, jolloin ne ovat osa reititystä.',
  share: 'Share itinerary',
  show: 'Show',
  'show-departures': 'Show departures',
  'show-more': 'Show more',
  'show-more-stops-near-you': 'Show more stops near you',
  'show-routes': 'Choose routes',
  'skip-positioning': 'Skip',
  'skip-to-content': 'Skip to content',
  slow: 'Slow',
  'specify-location': 'Specify location',
  speedtram: 'Light Rail',
  'speedtram-with-route-number': 'Light Rail {routeNumber} {headSign}',
  'splash-locating': 'Detecting location',
  'splash-or-choose': 'or select your origin',
  'splash-use-positioning': 'Use location services',
  'splash-welcome': 'How do you wish to start?',
  'splash-you-can-also': 'or',
  'standing-room-only': 'Standing room only',
  station: 'Station',
  'station-entrance': 'Entrance',
  'station-exit': 'Exit',
  stop: 'Stop',
  'stop-departure-time-future': 'Departure time is in {minutes} minutes',
  'stop-departure-time-past': 'Departure time was',
  'stop-list-update.sr-instructions': 'Departure times for each stop will update in real time.',
  'stop-near-you': 'Search stops and routes near you',
  'stop-near-you-modal-grant-permission': 'or enable location services',
  'stop-near-you-modal-grant-permission-info':
    'You can enable location services in your phone or browser settings, allowing the service to use your current location.',
  'stop-near-you-modal-header': 'You have not enabled location services',
  'stop-near-you-modal-info': 'Using the nearby stops function requires location access.',
  'stop-near-you-title': 'Search for stops and routes',
  'stop-near-you-update-alert': 'Nearest stops updated',
  'stop-number': 'Stop number',
  'stop-page.description': 'Stop {name} - {code}',
  'stop-page.right-now.loaded': 'stop page loaded',
  'stop-page.title': 'Stop {name} - {code}',
  'stop-page.title-short': 'Stop',
  'stop-virtual-monitor': 'Stop display',
  stops: 'Stops',
  'stops-near-you.description': 'Stop timetables and vehicles near your',
  'stops-near-you.title': 'Near by stops timetables',
  street: 'Street',
  'street-mode-bike-aria': 'Show cycle route. Duration {duration}, distance {length}',
  'street-mode-bikeandvehicle-aria':
    'Show a combination of cycling and public transport. Duration {duration}, distance {length}',
  'street-mode-car': 'Car',
  'street-mode-car-aria': 'Show driving route. Duration {duration}, distance {length}',
  'street-mode-car_park': 'Park & Ride',
  'street-mode-carandvehicle-aria':
    'Show a route that may include other modes of transport, such as car ferries. Duration {duration}, distance {length}',
  'street-mode-parkandride-aria': 'Show park and ride route. Duration {duration}, driving distance {length}',
  'street-mode-public_transport': 'Public transport',
  'street-mode-walk': 'Walking',
  'street-mode-walk-aria': 'Show walking route. Duration {duration}, distance {length}',
  subway: 'Metro',
  'subway-entrance.sr-description': 'Metro station entrance {entranceName}',
  'subway-entrance.sr-description.accessible': 'Metro station entrance {entranceName}, accessible',
  'subway-exit.sr-description': 'Metro station exit {entranceName}}',
  'subway-exit.sr-description.accessible': 'Metro station exit {entranceName}, accessible',
  'subway-with-route-number': 'Metro {routeNumber} {headSign}',
  'summary-page.description': '{from} - {to}',
  'summary-page.row-label': 'Itinerary suggestion {number}',
  'summary-page.title': 'Itinerary suggestions',
  surveillance_cameras: 'Camera surveillance',
  'swap-order-button-label': 'Reverse origin and destination',
  swedish: 'Swedish',
  'swipe-disruption-info': 'Disruption info  swipe result tabs',
  'swipe-disruption-info-header': 'Disruption info swipe result tabs.',
  'swipe-message-bar': 'Message swipe result tabs',
  'swipe-message-bar-header': 'Message swipe result tabs.',
  'swipe-result-tab-left': 'Press Enter or Space to show the previous tab.',
  'swipe-result-tab-right': 'Press Enter or Space to show the next tab.',
  'swipe-result-tabs': 'Switch tabs using arrow keys.',
  'swipe-sr-new-tab-opened': 'Tab {number} opened.',
  'swipe-stops-near-you': 'Stops near you swipe result tabs.',
  'swipe-stops-near-you-header': 'Stops near you swipe result tabs',
  'swipe-summary-page': 'Itinerary swipe result tabs',
  'swipe-summary-page-header': 'Itinerary swipe result tabs.',
  'terminal-page.description': 'Terminal {name}',
  'terminal-page.title': 'Terminal {name}',
  'terminal-page.title-short': 'Terminal',
  'terms-of-use': 'Terms of Use',
  'ticket-and-price-info': 'Ticket and price information',
  'ticket-single-adult': 'Adult',
  'ticket-type-none': 'No limits',
  tickets: 'Tickets',
  time: 'Time',
  'time-navigation-buttons': 'Time navigation buttons',
  'time-selector-form': 'Edit time',
  'time-selector-hours-label': 'Hour',
  'time-selector-minutes-label': 'Minute',
  timetable: 'Timetable',
  'to-bicycle': 'bicycle',
  'to-bus': 'bus',
  'to-e-scooter': 'scooter',
  'to-ferry': 'ferry',
  'to-frontpage': 'To the front page',
  'to-rail': 'train',
  'to-speedtram': 'light rail',
  'to-subway': 'subway',
  'to-tram': 'tram',
  today: 'Today',
  tomorrow: 'Tomorrow',
  track: 'Track',
  'track-num': 'Track {platformCode}',
  'track-short': 'Track {platformCode}',
  'track-short-no-num': 'Track',
  'tracking-button-off': 'tracking off',
  'tracking-button-offline': 'tracking failed',
  'tracking-button-on': 'tracking on',
  traficom: 'Traficom',
  tram: 'Tram',
  'tram-local': 'Local tram',
  'tram-with-route-number': 'Tram {routeNumber} {headSign}',
  transfer: 'Transfer',
  transfers: 'Number of transfers',
  'transfers-allowed': 'Transfers allowed',
  'transfers-margin': 'Transfer margin at least',
  'travel-time': '{min} min',
  'travel-time-label': 'Travel time',
  'travel-time-with-hours': '{h} h {min} min',
  'trip-co2-emissions': 'CO2 emissions of the journey',
  'trip-co2-emissions-sr': 'Carbondioxide emissions of the journey',
  'trip-information': 'Trip information',
  'trip-page.description': 'Route {route_short_name} - {route_long_name}',
  'trip-page.title': 'Route {route_short_name}',
  'try-again': 'Try again',
  'use-citybike': 'Start using',
  'use-national-service-postfix': '.',
  'use-national-service-prefix': 'We recommend you try the national journey planner, ',
  'use-own-position': 'Use current location',
  userinfo: 'My information',
  usermenu: 'User menu',
  'using-modes': 'I want to travel by',
  venue: 'Venue',
  'very-likely': 'Very likely',
  'very-unlikely': 'Very unlikely',
  'via-leg-stop-duration': 'At via point {stayDuration}',
  'via-point': 'Via point',
  'via-point-index': 'Via point {index}',
  'viapoint-slack-amount': 'Stop duration',
  'view-route': 'View Route',
  vr_ticket: 'VR ticket',
  wait: 'Wait',
  'wait-amount-of-time': 'Wait {duration}',
  'wait-in-vehicle': 'TODO_odota kulkuneuvossa',
  walk: 'walking',
  'walk-bike-itinerary-1': 'Your search returned only walking routes.',
  'walk-bike-itinerary-2': 'Your search returned only cycling routes.',
  'walk-bike-itinerary-3': 'Your search returned only walking and cycling routes.',
  'walk-bike-itinerary-4': 'Your search only returned routes requiring cycling or driving.',
  'walk-distance-duration': 'Walk {duration} ({distance})',
  'walk-only': 'Walking only',
  walking: 'Amount of walking',
  'walking-speed': 'Walking speed',
  'warning-call-agency': 'Only on demand: {routeName}, which needs to be booked in advance.',
  'warning-call-agency-no-route': 'Only on demand. Needs to be booked in advance.',
  weather: 'Weather',
  'weather-at-destination': 'Weather at the destination',
  'weather-data-source': 'Source: Finnish Meteorological Institute',
  'weather-detail-title': 'Weather forecast for the place of origin at ',
  'weather-icon-1': 'Clear',
  'weather-icon-2': 'Partly cloudy',
  'weather-icon-21': 'Light showers',
  'weather-icon-22': 'Showers',
  'weather-icon-23': 'Heavy showers',
  'weather-icon-3': 'Overcast',
  'weather-icon-31': 'Light rain',
  'weather-icon-32': 'Rain',
  'weather-icon-33': 'Heavy rain',
  'weather-icon-41': 'Light snow showers',
  'weather-icon-42': 'Snow showers',
  'weather-icon-43': 'Heavy snow showers',
  'weather-icon-51': 'Light snowfall',
  'weather-icon-52': 'Snowfall',
  'weather-icon-53': 'Heavy snowfall',
  'weather-icon-61': 'Thundershowers',
  'weather-icon-62': 'Heavy thundershowers',
  'weather-icon-63': 'Thunder',
  'weather-icon-64': 'Heavy thunder',
  'weather-icon-71': 'Light sleet showers',
  'weather-icon-72': 'Sleet showers',
  'weather-icon-73': 'Heavy sleet showers',
  'weather-icon-81': 'Light sleet',
  'weather-icon-82': 'Sleet',
  'weather-icon-83': 'Heavy sleet',
  'weather-icon-91': 'Mist',
  'weather-icon-92': 'Fog',
  where: 'Where to?',
  yesterday: 'Yesterday',
  zone: 'Zone',
  'zone-info': 'Zone {zone}',
  'zone-unknown': 'Unknown zone',
  zones: 'Fare zones',
};

export default en;
